module.exports = __webpack_public_path__ + "static/media/Artboard2.916d522f.png";